module.exports = __webpack_public_path__ + "img/featured_banner_02.a5e56cb9.jpg";